import React from 'react';
import Text from '@amzn/meridian/text';
import DisplaySubMetric from './DisplaySubMetric';
import Row from '@amzn/meridian/row';
import { FormattedMessage } from 'react-intl';
import { DisplaySubMetricsProps } from '../types';
import {
  HMDOfferRateDataCheck,
  SUBMETRIC_FONT_SIZE,
  SUBMETRIC_ROW_WIDTHS,
} from '../helper';
import { ControlledExpander } from './Util/ControlledExpander';
import Column from '@amzn/meridian/column';
import NoSubMetric from './Util/NoSubMetric';

const DisplayHMDOfferRateSubMetrics: React.FC<DisplaySubMetricsProps> = ({
  metrics,
}: DisplaySubMetricsProps): React.ReactElement => {
  if (!metrics.HMD_OFFER_RATE?.submetrics) {
    return <></>;
  }
  if (HMDOfferRateDataCheck(metrics.HMD_OFFER_RATE?.submetrics!)) {
    return <NoSubMetric />;
  }
  const { totalHandledContact } = metrics.HMD_OFFER_RATE?.submetrics!;

  return (
    <Column spacing='none' width='100%'>
      {totalHandledContact && (
        <Row
          alignmentVertical='top'
          width='100%'
          widths={SUBMETRIC_ROW_WIDTHS}
          spacing='none'
          spacingInset='none none 200'
        >
          <ControlledExpander
            title={
              <Text type={SUBMETRIC_FONT_SIZE}>
                <FormattedMessage
                  id='cs_perfportal_lighthouse_totalHandledContats'
                  defaultMessage='Total Handled Contacts'
                />
              </Text>
            }
            type='list'
          >
            <Text type={SUBMETRIC_FONT_SIZE}>
              <FormattedMessage
                id='cs_perfportal_lighthouse_totalHandledContats_def'
                defaultMessage="Sum of contacts considered 'Handled'."
              />
            </Text>
          </ControlledExpander>
          <DisplaySubMetric
            value={totalHandledContact.datapoint}
            isBold
            isPercentage
          />
          <DisplaySubMetric
            value={totalHandledContact.networkAverage}
            isPercentage
            datapointNull={totalHandledContact.datapoint === null}
          />
        </Row>
      )}
    </Column>
  );
};

export default DisplayHMDOfferRateSubMetrics;
